import React, { useEffect, useState } from "react";
import BenefitsTabs from "./components/MotorBenefitTabs";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { getMotorBenefitSummary, getSinglePolicy } from "store/thunk/kyp.thunk";
import Card from "components/common/Card";
import BenefitCard from "./components/MotorBenefitCard";
import PaymentCard from "../components/PaymentCard";
import Button from "components/semantic/Button";

const MotorbenefitSummary = () => {
  const navigate = useNavigate();
  const param: any = useParams();

  const dispatch = useAppDispatch();
  const benefitSummaryList = useAppSelector((state) => state.rootReducer.kypSlice.motorBenefitData);
  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.policyData);

  useEffect(() => {
    dispatch(getMotorBenefitSummary(param?.policyId));
    dispatch(getSinglePolicy(param?.policyId));
  }, [dispatch, param]);

  const [activeTab, setActiveTab] = useState("coverages");

  const handleNavigate = () => {
    switch (activeTab) {
      case "coverages":
        setActiveTab("addOns");
        break;

      case "addOns":
        navigate(`/kyp/kyp-motor-result/${param?.policyId}`);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <Card className="w-full" parentClassName="rounded-md md:rounded-lg border-2 border-gray-300 shadow-none">
        <BenefitsTabs activeTab={activeTab} setActiveTab={setActiveTab} benefitSumList={benefitSummaryList} />
        {benefitSummaryList ? (
          <>
            {activeTab == "coverages" && <BenefitCard id="coverages" cardData={benefitSummaryList?.coverages} />}
            {activeTab == "addOns" && <BenefitCard id="addOns" cardData={benefitSummaryList?.addOns} />}
          </>
        ) : (
          ""
        )}
      </Card>

      {activeTab === "addOns" && <div className="w-full flex justify-center px-3 py-4 mt-3 bg-[#EEFFE1] text-[13px] md:text-base font-normal md:font-extrabold border rounded-md md:rounded-lg shadow-none mb-10 text-sm border-l-[5px] border-[#beccb4]">Note- The highlighted add-ons are recommended to provide complete financial protection for your vehicle in the event of accidental damage or total loss, or theft.</div>}
      <Card className="w-full hidden md:flex justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none`}>
        <Button title="NEXT" onClick={handleNavigate} className={`${!["PAID", "WAIVEOFF"].includes(policyData?.kypPaymentStatus) && "pointer-events-none opacity-50"}`} />
      </Card>

      <Card className="w-full fixed bottom-0 left-0 rounded-t-[15px] bg-white flex md:hidden justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none `}>
        <Button title="NEXT" onClick={handleNavigate} className={`${!["PAID", "WAIVEOFF"].includes(policyData?.kypPaymentStatus) && "pointer-events-none opacity-50"}`} />
      </Card>

      {!["PAID", "WAIVEOFF"].includes(policyData?.kypPaymentStatus) && <PaymentCard feeAmount={policyData?.kypFeeAmount} />}
    </>
  );
};

export default MotorbenefitSummary;
